import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { $mapLoaded } from '../../../models/mapModel/index.js';

function WorldLine() {
  const mapLoaded = useUnit($mapLoaded);

  const createLayer = (update) => {
    const pointsData = {
      type: 'FeatureCollection',
      features: [],
    };

    const lineData = {
      type: 'FeatureCollection',
      features: [],
    };

    if (update) {
      window.map.getSource('world_points_source').setData(pointsData);
      window.map.getSource('world_line_source').setData(lineData);
    } else {
      if (!window.map.getSource('world_points_source')) {
        window.map.addSource('world_points_source', {
          type: 'geojson',
          data: pointsData,
        });
      }

      if (!window.map.getSource('world_line_source')) {
        window.map.addSource('world_line_source', {
          type: 'geojson',
          data: lineData,
        });
      }

      if (!window.map.getLayer('world_points_layer')) {
        window.map.addLayer({
          id: 'world_points_layer',
          type: 'circle',
          source: 'world_points_source',
          paint: {
            'circle-color': '#374151',
            'circle-radius': 5,
            'circle-stroke-color': '#90969f',
            'circle-stroke-width': 3,
          },
        });
      }

      if (!window.map.getLayer('world_line_layer')) {
        window.map.addLayer({
          id: 'world_line_layer',
          type: 'line',
          source: 'world_line_source',
          paint: {
            'line-color': 'red',
            'line-width': 3,
            'line-dasharray': [0, 4, 3],
          },
        });

        const dashArraySequence = [
          [0, 4, 3],
          [0.5, 4, 2.5],
          [1, 4, 2],
          [1.5, 4, 1.5],
          [2, 4, 1],
          [2.5, 4, 0.5],
          [3, 4, 0],
          [0, 0.5, 3, 3.5],
          [0, 1, 3, 3],
          [0, 1.5, 3, 2.5],
          [0, 2, 3, 2],
          [0, 2.5, 3, 1.5],
          [0, 3, 3, 1],
          [0, 3.5, 3, 0.5],
        ];

        let step = 0;

        function animateDashArray(timestamp) {
          // Update line-dasharray using the next value in dashArraySequence. The
          // divisor in the expression `timestamp / 50` controls the animation speed.
          const newStep = parseInt((timestamp / 50) % dashArraySequence.length);

          if (newStep !== step) {
            window.map.setPaintProperty(
              'world_line_layer',
              'line-dasharray',
              dashArraySequence[step]
            );
            step = newStep;
          }

          // Request the next frame of the animation.
          requestAnimationFrame(animateDashArray);
        }

        animateDashArray(0);
      }

      setTimeout(() => {
        window.map.moveLayer(`world_points_layer`);
        window.map.moveLayer(`world_line_layer`);
      }, 500);
    }
  };

  useEffect(() => {
    if (mapLoaded) {
      if (window.map.getLayer('world_points_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        });
      }
    }
  }, [mapLoaded]);

  return null;
}

export default WorldLine;
